function CommonFooter() {
    return <footer>
        <img src="/assets/logo-ncl.svg" alt="Newcastle University logo"/>
        <img src="/assets/logo-uon.svg" alt="University of Nottingham logo"/>
        <img src="/assets/logo-cdt.svg" alt="Geospatial Systems CDT logo"/>
        <img src="/assets/logo-ukri.svg" alt="UKRI logo"/>
        <img src="/assets/logo-uksa.png" alt="UK Space Agency logo"/>
    </footer>;
}

export default CommonFooter;